import { css } from '@emotion/react'

// In this Vite + custom server setup, requesting *.ttf?import is served as a font (MIME font/ttf),
// which breaks ESM asset imports. Reference the font as a static URL instead.
const fonts = {
	BalletHarmony: '/fonts/BalletHarmony.ttf',
}

const fontFaces = {}

Object.keys(fonts).forEach((font_name) => {
	fontFaces[font_name] = css`
		@font-face {
			font-family: ${font_name};
			src: url('${fonts[font_name]}') format('truetype');
		}
	`
})

export default fontFaces
